import { type Purchase } from "./purchasesTypes";

export const hasSomePackages = (purchase: Purchase): boolean => purchase.shipping.parcels.length > 0;
